import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyTableModule as MatTableModule } from '@angular/material/legacy-table';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AuthenticationEffects } from '@authentication/store/authentication.effects';
import { AuthenticationFeature } from '@authentication/store/authentication.slice';
import { SharedModule } from '@shared/shared.module';

import { BasketDiscountsRoutingModule } from './basket-discounts-routing.module';
import { BasketDiscountsComponent } from './basket-discounts.component';
import { BasketDiscountsEffects } from './store/basket-discounts.effects';
import { BasketDiscountsFeature } from './store/basket-discounts.slice';

@NgModule({
  declarations: [BasketDiscountsComponent],
  imports: [
    CommonModule,
    BasketDiscountsRoutingModule,
    StoreModule.forFeature(BasketDiscountsFeature),
    StoreModule.forFeature(AuthenticationFeature),
    EffectsModule.forFeature([BasketDiscountsEffects, AuthenticationEffects]),
    MatTableModule,
    SharedModule,
  ],
})
export class BasketDiscountsModule {}
